import { render, staticRenderFns } from "./pci-dss-payment-form.vue?vue&type=template&id=1834e138"
import script from "./pci-dss-payment-form.vue?vue&type=script&lang=js"
export * from "./pci-dss-payment-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports